import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useHeaderMenu } from '@src/state/headerMenu';
import { config } from '@uhg-abyss/web/tools/config';
import { Dropdown } from '@src/common/Dropdown';
import { PageLayout } from '@src/common/PageLayout';
import { MyAccountButton } from './MyAccountButton';
import { event } from '@uhg-abyss/web/tools/event';

const DropDownItem = styled('li', {
  paddingTop: 10,

  '&:first-child': {
    paddingTop: 0,
  },
});
const DropdownContent = {
  right: 0,
  width: 190,
  backgroundColor: '$primary2',
  boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.5)',
  textAlign: 'left',
  marginTop: '5px',
  padding: '20px 15px',
  fontSize: 13,
};

export const MyAccount = () => {
  const { toggleMyAccount } = useHeaderMenu.actions();

  const handleChange = (isActive) => {
    if (!isActive) {
      toggleMyAccount(false);
    }
  };

  const handleAccountInfoClick = () => {
    event('ACCOUNT_INFORMATION_CLICK');
  };

  const handleCommPrefClick = () => {
    event('COMMUNICATION_PREFERENCES_CLICK');
  };

  const handleSignOutClick = () => {
    event('SIGN_OUT_CLICK');
  };

  return (
    <PageLayout>
      <Dropdown model="my-account" onChange={handleChange}>
        {({ openDropdown, closeDropdown, isActive }) => {
          return (
            <React.Fragment>
              <Dropdown.Button
                data-testid="top-bar-my-account-link"
                aria-label="click to open my Account dropdown"
              >
                <MyAccountButton
                  openDropdown={openDropdown}
                  isActive={isActive}
                />
              </Dropdown.Button>
              <Dropdown.Content
                style={DropdownContent}
                data-testid="top-bar-my-account-link"
              >
                <ul>
                  <DropDownItem>
                    <a
                      data-testid="top-bar-account-info-link"
                      target="_blank"
                      href={`${config('ACCOUNT_INFO_URL')}`}
                      rel="noopener noreferrer"
                      onClick={handleAccountInfoClick}
                    >
                      Account Information
                    </a>
                  </DropDownItem>

                  <DropDownItem>
                    <a
                      data-testid="top-bar-comm-pref-link"
                      target="_blank"
                      href={`${config('COMMUNICATION_PREF_URL')}`}
                      rel="noopener noreferrer"
                      onClick={handleCommPrefClick}
                    >
                      Communication Preferences
                    </a>
                  </DropDownItem>

                  <DropDownItem>
                    <a
                      data-testid="top-bar-sign-out-link"
                      href={`${config('IDENTITY_API_URL')}/logout`}
                      onClick={handleSignOutClick}
                    >
                      Sign Out
                    </a>
                  </DropDownItem>
                </ul>
              </Dropdown.Content>
            </React.Fragment>
          );
        }}
      </Dropdown>
    </PageLayout>
  );
};
